import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

class TabsTwo extends Component {
    render() {
        let
            tab1 = "Main Skills",
            tab2 = "Awards",
            tab3 = "Experience",
            tab4 = "Education";
        const { tabStyle } = this.props
        return (
            <div>
                {/* Start Tabs Area */}
                <div className="tabs-area">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <Tabs>
                                    <TabList className={`${tabStyle}`}>
                                        <Tab>{tab1}</Tab>
                                        <Tab>{tab2}</Tab>
                                        <Tab>{tab3}</Tab>
                                        <Tab>{tab4}</Tab>
                                    </TabList>

                                    <TabPanel>
                                        <div className="single-tab-content">
                                            <ul>
                                                <li>
                                                    <a>Front-End Web Development</a>
                                                    Designing the web interface and implementing it with codes.
                                                </li>
                                                <li>
                                                    <a>Back-End Web Development</a>
                                                    Supplying various kinds of data model according to what the front-end needs.
                                                </li>
                                                <li>
                                                    <a>Mobile App Development</a>
                                                    Just like front-end web but manifested in mobile app.
                                                </li>
                                            </ul>
                                        </div>
                                    </TabPanel>

                                    <TabPanel>
                                        <div className="single-tab-content">
                                            <ul>
                                                <li>
                                                    <a>Ame Yume Band Competition <span>- 2nd Winner</span></a> 2016
                                                </li>
                                                <li>
                                                    <a>The Grand Champion in Junior High School <span>- 1st student with highest grade</span></a> 2013
                                                </li>
                                                <li>
                                                    <a>Quiz/Cerdas Cermat Junior High School <span>- 2nd Winner</span></a> 2012
                                                </li>
                                                <li>
                                                    <a>Google Play Store Hidden Gem Apps (Atourin) <span>- Honnorable Mention</span></a> 2022
                                                </li>
                                            </ul>
                                        </div>
                                    </TabPanel>



                                    <TabPanel>
                                        <div className="single-tab-content">
                                            <ul>
                                                <li>
                                                    <a>Freelance Software Engineer </a> 2020 - Now
                                                </li>
                                               
                                                <li>
                                                    <a>Mobile App Developer<span> - Simedic Hadejun Indonesia </span></a> 2022
                                                </li>
                                                <li>
                                                    <a>Mobile App Developer<span> - Atourin </span></a> 2021-2022
                                                </li>
                                                <li>
                                                    <a>Front-End Web Developer<span> - Pojok Satu Indonesia </span></a> 2019-2021
                                                </li>
                                                <li>
                                                    <a>Social Media Officer<span> - Pojok Satu Indonesia </span></a> 2017- 2019
                                                </li>
                                            </ul>
                                        </div>
                                    </TabPanel>

                                    <TabPanel>
                                        <div className="single-tab-content">
                                            <ul>
                                                <li>
                                                    <a>Bina Sarana Informatika Cilebut</a> 2022
                                                </li>
                                                <li>
                                                    <a>SMA Negeri 5 Bogor</a> 2016
                                                </li>
                                                <li>
                                                    <a>SMP Rimba Teruna</a> 2013
                                                </li>
                                                <li>
                                                    <a>SMP Negeri 7 Salatiga</a> 2010
                                                </li>
                                                <li>
                                                    <a>SDN Pamulang Permai Tangerang Selatan</a> 2010
                                                </li>
                                            </ul>
                                        </div>
                                    </TabPanel>

                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Tabs Area */}
            </div>
        )
    }
}



export default TabsTwo;